module.exports = __webpack_public_path__ + "img/check.c06f9c92.svg";